import { html, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { QuestionBase } from "@/components/composite/question_base";
import { generateUniqueId } from "@/utilities";

type OpenQuestionConfig = { id: string; type: "open-question"; prompt: string };

@customElement("d-open-question")
export class OpenQuestion extends QuestionBase {
    declare config: OpenQuestionConfig;

    inputId: string = generateUniqueId();

    protected render(): TemplateResult {
        return html`
            <label class="form-label" for="${this.inputId}">${this.config.prompt}</label>
            <textarea
                id="${this.inputId}"
                class="form-control"
                rows="4"
                @input=${(e: Event) => this.setValue((e.target as HTMLTextAreaElement).value)}
            ></textarea>
        `;
    }
}
